import React, { useState, useEffect, useRef } from "react";
import "../AddClients/tableStyle.css";
import { freightPaymetGet, freightPaymet } from "../../Services/Services";
import { Col, Input, Button, Form, Modal, Row } from "antd"; // Import DatePicker
import "../AddClients/tableStyle.css";
import Header from "../Header-Footer/Header";
import { useReactToPrint } from "react-to-print";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import Footer from "../Header-Footer/Footer";
import FreightPaymentSearch from "./FreightPaymentSearch";
export default function FreightPayment() {
  const [deliveryOrder, setDeliveryOrder] = useState([]);
  const [orderList, setOrderList] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDo, setSelectedDo] = useState({});

  const [form] = Form.useForm();
  useEffect(() => {
    GetDeliveryOrderDetails();
  }, []);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const GetDeliveryOrderDetails = async () => {
    const response = await freightPaymetGet({
      com_name: localStorage.getItem("com_name"),
    });
    if (response) {
      const sortedArray = [...response].sort((a, b) => b.id - a.id);
      setDeliveryOrder(sortedArray);
      setOrderList(sortedArray);
    }
  };

  const handleExportToExcel = () => {
    const workbook = XLSX.utils.book_new();
    const wsData = deliveryOrder.map((e, index) => [
      index + 1,
      e.client_name,
      e.do_no,
      e.truck_owner_name,
      e.vehicle_no,
      e.pan_no,
      e.dispatch_quantity,
      e.received_quantity,
      e.freight_quantity,
      e.sort_quantity,
      e.moisture_received_per,
      e.actual_quantity,
      e.moisture_deduct_quantity,
      e.moisture_amount,
      e.moisture_deduct,
      e.sort_amount,
      e.freight_rate,
      e.freight_amount,
      e.tds_per,
      e.tds,
      e.advance,
      e.commision,
      e.pay_amount,
      e.date,
      // Add other fields here based on your table structure
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([
      [
        "Sr. No",
        "Party Name",
        "Do Number",
        "Truck Owner Name",
        "Vehicle No",
        "Pan No",
        "Dipatch Qty",
        "Recieved Qty",
        "Freight Qty",
        "Sort Qty",
        "Moisture",
        "Actual Qty",
        "Moisture Deduct Qty",
        "Moisture Amt",
        "Moisture Deduct",
        "Sort Amount",
        "Freight Rate",
        "Freight Amt",
        "Tds %",
        "Tds Amt",
        "Advance Amt",
        "Commision Amt",
        "Pay Amt",
        "Received Date",
        // Add other headers here based on your table structure
      ],
      ...wsData,
    ]);

    XLSX.utils.book_append_sheet(workbook, worksheet, "DeliveryOrderDetails");

    XLSX.writeFile(workbook, "Freight Payment.xlsx");
  };

  const showModal = (do_id) => {
    const do_data = deliveryOrder.find((o) => o.id === do_id);
    setSelectedDo(do_data);
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const onFinish = async (values) => {
    Object.assign(values, {
      order_id: selectedDo.id,
      com_name: localStorage.getItem("com_name"),
    });
    const response = await freightPaymet(values);
    if (response) {
      form.resetFields();
      setIsModalOpen(false);
      setDeliveryOrder(response);
      setOrderList(response);
    }
  };
  const formateDate = (date) => {
    const [year, month, day] = date.split("-");
    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate;
  };

  return (
    <div>
      <Header heading="FREIGHT PAYMENT" />
      <Modal
        visible={isModalOpen} // Correct prop name is visible, not open
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        // width={200}
      >
        <Row style={{ backgroundColor: "#a1a19b", padding: "10px" }}>
          <Col span={12}>
            <h5>
              <b>Do No - {selectedDo.do_no}</b>
            </h5>
            <h5>
              <b>Pan No - {selectedDo.pan_no}</b>
            </h5>
          </Col>
          <Col span={12}>
            <h5>
              <b>Truck Owner Name - {selectedDo.truck_owner_name}</b>
            </h5>
            <h5>
              <b>Pay Amt - {selectedDo.pay_amount}</b>
            </h5>
          </Col>
        </Row>

        <Form form={form} onFinish={onFinish} layout="vertical">
          <Form.Item
            name="aadhar_no"
            label={<b>Aadhar No</b>}
            style={{ padding: "0px", margin: "1px" }}
          >
            <Input placeholder="Aadhar No" maxLength={12} />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
                message: "Please Enter Check No!",
              },
            ]}
            name="check_no"
            label={<b>Check No</b>}
            style={{ padding: "0px", margin: "1px" }}
          >
            <Input placeholder="Check No" maxLength={15} />
          </Form.Item>

          <Form.Item
            rules={[
              {
                required: true,
                message: "Please Enter Check Date!",
              },
            ]}
            name="check_date"
            label={<b>Check Date</b>}
            style={{ padding: "0px", margin: "1px" }}
          >
            <Input placeholder="Check Date" type="date" />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
                message: "Please Enter Bank Name!",
              },
            ]}
            name="bank_name"
            label={<b>Bank Name</b>}
            style={{ padding: "0px", margin: "1px" }}
          >
            <Input placeholder="Bank Name" />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
                message: "Please Enter ISFC Code!",
              },
            ]}
            name="ifsc_code"
            label={<b>ISFC Code</b>}
            style={{ padding: "0px", margin: "1px" }}
          >
            <Input placeholder="ISFC Code" />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
                message: "Please Enter Account No!",
              },
            ]}
            name="account_no"
            label={<b>Account No</b>}
            style={{ padding: "0px", margin: "1px" }}
          >
            <Input placeholder="Account No" />
          </Form.Item>
          <Form.Item
            className="text-center"
            style={{ textAlign: "center", padding: "0px", margin: "2px" }}
          >
            <Button
              htmlType="submit"
              style={{ color: "white", backgroundColor: "black" }}
            >
              Save
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <div>
        <FreightPaymentSearch
          setDeliveryOrder={setDeliveryOrder}
          orderList={orderList}
          handleExportToExcel={handleExportToExcel}
          handlePrint={handlePrint}
        />
      </div>
      <div className="table-wrapper" ref={componentRef} style={{ maxHeight: "500px", overflowX: "auto", overflowY: "auto" }}>
        <table id="my-table" className="w-full">
          <thead className="bg-[#151B54] w-full text-white">
            <tr>
              <th>Sr. No</th>
              <th>Id</th>
              <th>Do No</th>
              <th>Truck Owner Name</th>
              <th>Vehicle No</th>
              <th>Pan No</th>
              <th>Dipatch Qty</th>
              <th>Recieved Qty</th>
              <th>Freight Qty</th>
              <th>Sort Qty</th>
              <th>Moisture %</th>
              <th>Actual Qty</th>
              <th>Moisture Deduct Qty</th>
              <th>Moisture Amt</th>

              <th>Moisture Deduct</th>
              <th>Sort Amount</th>
              <th>Freight Rate</th>
              <th>Freight Amt</th>
              <th>Tds %</th>
              <th>Tds Amt</th>
              <th>Advance Amt</th>
              <th>Commision Amt</th>
              <th>Pay Amt</th>
              <th>Dispatch Date</th>
              <th>Received Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {deliveryOrder.map((e, index) => (
              <tr
                key={e.id}
                style={{ backgroundColor: e.is_applicable ? "#fbd9d3" : "" }}
              >
                <td>{index + 1}</td>
                <td>{e.id}</td>
                <td>
                  <Link to={`/do-view/${e.do_id}`}>
                    <u style={{ fontWeight: "600", color: "blue" }}>
                      {e.do_no}
                    </u>
                  </Link>
                </td>
                <td>{e.truck_owner_name}</td>
                <td>{e.vehicle_no}</td>
                <td>{e.pan_no}</td>
                <td>{e.dispatch_quantity.toFixed(3)}</td>
                <td>{e.received_quantity.toFixed(3)}</td>
                <td>{e.freight_quantity.toFixed(3)}</td>
                <td>{e.sort_quantity}</td>
                <td>{e.moisture_received_per}</td>
                <td>{e.actual_quantity}</td>
                <td>{e.moisture_deduct_quantity}</td>
                <td>{e.moisture_amount}</td>
                <td>{e.moisture_deduct}</td>
                <td>{e.sort_amount}</td>
                <td>{e.freight_rate}</td>
                <td>{e.freight_amount}</td>
                <td>{e.tds_per}</td>
                <td>{e.tds}</td>
                <td>{e.advance}</td>
                <td>{e.commision}</td>
                <td>{e.pay_amount}</td>
                <td>{formateDate(e.date)}</td>
                <td>{formateDate(e.received_date)}</td>
                <td>
                  <Button
                    type="link"
                    style={{
                      color: "blue",
                      padding: 0,
                    }}
                    disabled={e.is_applicable}
                    onClick={() => showModal(e.id)}
                  >
                    <span style={{ textDecoration: "underline" }}>Payment</span>
                  </Button>
                </td>
              </tr>
            ))}
            <tr style={{ backgroundColor: "#e9e9e9" }}>
              <td
                className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"
                colSpan={6}
              >
                <b>Total</b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.dispatch_quantity,
                      0
                    )
                    .toFixed(3)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.received_quantity,
                      0
                    )
                    .toFixed(3)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.freight_quantity,
                      0
                    )
                    .toFixed(3)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>

              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>

              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.moisture_amount,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.moisture_deduct,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.sort_amount,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>

              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.freight_amount,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.tds,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.advance,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.commision,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.pay_amount,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td
                className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"
                colSpan={3}
              ></td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* <Footer /> */}
    </div>
  );
}
